exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2OGP4{margin-bottom:96px;margin-bottom:6rem}._2OGP4,._3mVbJ{width:100%;position:relative;top:64px;top:4rem;overflow:hidden}._3mVbJ{margin-bottom:0}@-moz-document url-prefix(){._2OGP4{width:100%;position:relative;top:4rem;overflow:hidden;margin-bottom:10rem}}@media only screen and (max-width:480px){._2OGP4{width:100%;margin-left:auto;margin-right:auto}}@media only screen and (max-width:836px){._2OGP4{margin-left:auto;margin-right:auto;width:100%}}", ""]);

// exports
exports.locals = {
	"container": "_2OGP4",
	"no_margin": "_3mVbJ"
};